import Enumeration from "./Enumeration";

const CredentialType = new Enumeration({
  USER: "USER",
  AGENT: "AGENT",
  PAYMENT_PARTNER: "PAYMENT_PARTNER",
  TRANSACTING_PARTNER: "TRANSACTING_PARTNER",
  REGISTERING_PARTNER: "REGISTERING_PARTNER",
});
export default CredentialType;



// WEBPACK FOOTER //
// ./src/domain/CredentialType.js